import { useQuery, gql } from '@apollo/client'
import { useEffect } from 'react'
import { defineMessages, useIntl } from 'react-intl'
import { useLocation, useParams } from 'react-router-dom'
import { ContentBody } from 'components/v2/Content'
import { ForbiddenView } from 'features/App/components/ForbiddenView'
import { withLastUrl } from 'features/App/components/WithLastUrl'
import { CartTabs } from 'features/Carts/components/Tabs'
import { InventoryHeader } from 'features/Inventories/components/InventoryHeader'
import { InventoryContent } from 'features/Inventories/components/InventoryContent'
import { withInventoryWastes } from 'features/Inventories/components/WithInventoryWastes'
import { FEATURES } from 'features/Roles/components/Permissions/constants'
import { useSanitizeItem } from 'resolvers/items'
import { getQueries } from 'utils/route'
import { canReadCart } from 'features/Users/utils'
import { WastesFilters } from './Filters'
import { WastesList } from './List'
import { WastesPagination } from './Pagination'
import { useLogin } from 'features/Login/hooks'

const messages = defineMessages({
  helmet: {
    id: 'carts.wastes.helmet',
    defaultMessage: 'Wastes | Nexbus Admin'
  }
})

const GET_CART = gql`
  query GetCart($cartId: ID!) {
    cart(input: { id: $cartId }) {
      id
      name
    }
  }
`

const CartWastes = withInventoryWastes(WastesList, WastesPagination)

const CartWastesView = (): TSFixMe => {
  const location = useLocation()
  const { cartId } = useParams()
  const intl = useIntl()

  const login = useLogin()
  const hasReadPermission = canReadCart(login.accessToken.policies)

  useEffect(() => {
    document.title = intl.formatMessage(messages.helmet)
  }, [])

  const { data: cartData } = useQuery(GET_CART, {
    variables: {
      cartId
    },
    skip: !hasReadPermission
  })
  // eslint-disable-next-line prefer-const
  let { page = 1, id = '', itemId = '' } = getQueries(location.search)
  const { companyId } = login.accessToken
  const sanitizedItem = useSanitizeItem(itemId, companyId)

  if (!hasReadPermission) {
    return <ForbiddenView feature={FEATURES.INVENTORY} />
  }

  // @ts-expect-error TS(2559) FIXME Remove this comment to see the full error message
  page = parseInt(page)

  return (
    <>
      <InventoryHeader inventory={cartData && cartData.cart} />
      <CartTabs cartId={cartId} />
      <InventoryContent>
        <ContentBody>
          <WastesFilters
            filters={{
              id,
              item: sanitizedItem
            }}
            cartId={cartId}
            companyId={companyId}
          />
          <CartWastes
            page={page}
            inventoryId={cartId}
            cart={cartData && cartData.cart}
            cartId={cartId}
            urls={{
              list: `/carts/${cartId}/wastes`,
              new: `/carts/${cartId}/remove-bulk-items`
            }}
            filters={{
              id,
              itemId
            }}
          />
        </ContentBody>
      </InventoryContent>
    </>
  )
}

export default withLastUrl(CartWastesView)
